/**
 * Dynamic Side Navigation with Smooth Scroll & Scroll Highlight
 * Fully Configurable - Fixed Header Offset Support
 */
document.addEventListener('DOMContentLoaded', () => {
  initCustomSideNav({
    sideNavContainer: '.side-nav',
    sectionSelector: '.about-side-section',
    navItemClass: 'side-nav-item',
    activeClass: 'active',
    // Offset for fixed header (adjust this value to match your header height)
    fixedHeaderOffset: 80,
    scrollBehavior: 'smooth'
  });
});

/**
 * Initialize fully customizable side navigation
 * @param {Object} options - Configuration options
 */
function initCustomSideNav(options) {
  const {
    sideNavContainer,
    sectionSelector,
    navItemClass,
    activeClass,
    fixedHeaderOffset,
    scrollBehavior
  } = options;

  // Get DOM elements
  const sideNav = document.querySelector(sideNavContainer);
  const sections = document.querySelectorAll(sectionSelector);

  // Exit if required elements do not exist
  if (!sideNav || sections.length === 0) return;

  // Generate navigation items
  const navItems = createNavItems({
    sideNav,
    sections,
    navItemClass
  });

  // Set first item as active by default
  setActiveItem(navItems, 0, activeClass);

  // Bind click to scroll behavior with header offset
  bindScrollToSection({
    navItems,
    activeClass,
    fixedHeaderOffset,
    scrollBehavior
  });

  // Bind scroll highlight behavior with header offset
  bindScrollHighlight({
    sections,
    navItems,
    activeClass,
    fixedHeaderOffset
  });

  
  bindCustomJumpByIndex({ sections, fixedHeaderOffset, scrollBehavior });
}

/**
 * Dynamically create side navigation items from page sections
 * @param {Object} params - Parameters
 * @returns {NodeList} Generated nav items
 */
function createNavItems({ sideNav, sections, navItemClass }) {
  sections.forEach(section => {
    const sectionId = section.id;
    if (!sectionId) return;

    const navItem = document.createElement('div');
    navItem.className = navItemClass;
    navItem.dataset.section = sectionId;
    sideNav.appendChild(navItem);
  });

  return sideNav.querySelectorAll(`.${navItemClass}`);
}

/**
 * Set active state for a navigation item by index
 * @param {NodeList} items - All nav items
 * @param {number} index - Index to activate
 * @param {string} activeClass - Active CSS class
 */
function setActiveItem(items, index, activeClass) {
  items.forEach(item => item.classList.remove(activeClass));
  items[index]?.classList.add(activeClass);
}

/**
 * Bind smooth scroll behavior with fixed header offset
 * Prevents section from hiding under the top navigation bar
 * @param {Object} params - Parameters
 */
function bindScrollToSection({ navItems, fixedHeaderOffset, scrollBehavior }) {
  navItems.forEach(item => {
    item.addEventListener('click', () => {
      const targetId = item.dataset.section;
      const targetSection = document.getElementById(targetId);
      
      if (!targetSection) return;

      // Calculate scroll position with fixed header offset
      const sectionTop = targetSection.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = sectionTop - fixedHeaderOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: scrollBehavior
      });
    });
  });
}

/**
 * Auto-highlight nav item when scrolling with fixed header offset
 * @param {Object} params - Parameters
 */
function bindScrollHighlight({ sections, navItems, activeClass, fixedHeaderOffset }) {
  window.addEventListener('scroll', () => {
    const scrollY = window.pageYOffset;
    let currentSectionId = '';

    sections.forEach(section => {
      const sectionTop = section.offsetTop - fixedHeaderOffset;
      if (scrollY >= sectionTop) {
        currentSectionId = section.id;
      }
    });

    // Find and activate matching nav item
    const targetIndex = Array.from(navItems).findIndex(
      item => item.dataset.section === currentSectionId
    );
    
    setActiveItem(navItems, targetIndex, activeClass);
  });
}
/**
 * Bind custom jump to section by index
 * @param {Object} params - Parameters
 */
function bindCustomJumpByIndex({ sections, fixedHeaderOffset, scrollBehavior }) {
  const buttons = document.querySelectorAll('[data-jump-index]');
  buttons.forEach(btn => {
    btn.addEventListener('click', () => {
      const index = parseInt(btn.dataset.jumpIndex) - 1; // 转成从0开始
      const targetSection = sections[index];
      if (!targetSection) return;

      const sectionTop = targetSection.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = sectionTop - fixedHeaderOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: scrollBehavior
      });
    });
  });
}

// Carousel functionality
// const slides = document.querySelectorAll('.carousel-slide');
// const dots = document.querySelectorAll('.carousel-dot');
// let currentSlide = 0;

// // Set initial active dot
// dots[0].classList.add('opacity-100');
// dots[0].classList.remove('opacity-50');

// // Function to show slide
// function showSlide(index) {
//     slides.forEach((slide, i) => {
//         slide.style.opacity = i === index ? '1' : '0';
//     });
    
//     dots.forEach((dot, i) => {
//         if (i === index) {
//             dot.classList.add('opacity-100');
//             dot.classList.remove('opacity-50');
//         } else {
//             dot.classList.add('opacity-50');
//             dot.classList.remove('opacity-100');
//         }
//     });
    
//     currentSlide = index;
// }

// Auto carousel
// setInterval(() => {
//     currentSlide = (currentSlide + 1) % slides.length;
//     showSlide(currentSlide);
// }, 5000);

// Dot click event
// dots.forEach((dot, index) => {
//     dot.addEventListener('click', () => {
//         showSlide(index);
//     });
// });

// Initialize AOS
document.addEventListener('DOMContentLoaded', function() {
    AOS.init({
        duration: 800,
        easing: 'ease-in-out',
        once: true
    });
    
    // Initialize Swiper for global section
    const globalSwiper = new Swiper('.global-swiper', {
        slidesPerView: 1.5,
        spaceBetween: 8,
        loop: true,
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            320: {
                slidesPerView: 2,
                spaceBetween: 8,
            },
            480: {
                slidesPerView: 2,
                spaceBetween: 6,
            },
            640: {
                slidesPerView: 3,
                spaceBetween: 6,
            }, 
            768: {
                slidesPerView: 4,
                spaceBetween: 8,
            },
        }
    });
    
    // Count animation function
    function animateCounter(element) {
        const target = parseInt(element.getAttribute('data-target'));
        const duration = 2000; // Animation duration in milliseconds
        const step = target / (duration / 16); // 60fps
        let current = 0;
        
        const timer = setInterval(() => {
            current += step;
            if (current >= target) {
                current = target;
                clearInterval(timer);
            }
            
            // Format the number with commas for thousands
            const formattedNumber = current.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            
            // Add the '+' symbol at the end
            element.textContent = formattedNumber + '+';
        }, 16);
    }
    
    // Intersection Observer to detect when elements come into view
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                animateCounter(entry.target);
                observer.unobserve(entry.target);
            }
        });
    }, {
        threshold: 0.5
    });
    
    // Observe all counter elements
    document.querySelectorAll('.global-stat-number').forEach(counter => {
        observer.observe(counter);
    });
});